// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__1aHo3","round":"Chip_round__U0ohi","default":"Chip_default__cHJHB"};